// extracted by mini-css-extract-plugin
module.exports = {"link":"GButton_link_1h-fd","disabled":"GButton_disabled_1Vo5p"};